export default __webpack_public_path__ + "static/media/facebook.ca529b2d.svg";